var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 241,
    viewBox: "0 0 158 241",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "v531xzn4da",
    d: "M0 241h158V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.013 70.643c3.777 9.762 18.06 10.745 20.777-.468 7.8-1.367 11.49 5.511 13.88 12.622 1.496 4.447 2.774 8.986 3.33 11.655-4.478 2.804-7.936 3.682-7.936 3.916 0 4.102-2.097 10.666-2.346 14.856-.252 4.232.024 9.125-.009 13.921-.004.705-1.733.238-1.754.936-.108 3.602.587 8.19.283 11.278-12.828.106-26.884 1.063-39.607.42-.518-6.172 5.696-35.154-2.583-36.615-.42-7.176 2.015-13.892 3.404-20.472.94-4.445 10.133-14.579 13.97-10.645",
    fill: "#F69536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8AF66",
    d: "m97 79-28.8.722-2.73 21.207L64 127h30.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.659 26.01c13.537-.47 14.47 16.745 9.783 25.538-2.553 4.788-7.251 8.03-12.974 7.366-5.609-.65-7.913-7.128-8.363-11.787-.42-4.356.465-9.01 1.95-12.886 2.132-5.566 5.373-7.54 9.25-8.232",
    fill: "#9C7141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.047 29c5.883-4.263 7.531-16.03-.67-17.821-3.478-.76-7.015.91-8.46 4.805-1.56 4.209-1.078 8.04 1.053 11.405",
    fill: "#68493B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 59c-.79 4.983-1.452 9.268-3 13M75 56c-.93 3.615-3.054 13.814-2.999 12.948",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 38.661C66.152 34.89 64.376 48.468 71.857 49M95.68 41.093c6.966-1.238 4.85 10.258-1.68 9.899",
    fill: "#9C7141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 44c-1.2 1.362-1.691 2.18-3 3M73 43c-.008-.007-2.894-2.92-3-3M90.684 40c-.046 1.444-.046 2.445-.368 4M79.684 40c-.093 1.594-.23 2.016-.368 3M86.882 40c.045 1.43.92 8.26-2.882 5.235",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.73 49.734c-3.924 0-6.343-.11-9.709-1.734-.201 3.203 1.032 5.314 3.724 5.861 3.674.75 5.301-1.667 6.255-4.127",
    fill: "#F0612B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 69.828c3.055-.788 4.61-1.032 6.396-.653 2.662.563 4.916 1.722 6.492 4.07 1.836 2.73 2.585 5.973 3.566 9.1a269.716 269.716 0 0 1 2.386 7.985c.854 3.041 2.08 8.784 2.16 8.668",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.466 99.853c1.694-2.815 11.075-15.337 13.861-19.793.84-1.343 1.651-2.724 3.258-2.944 1.675-.23 3.191.114 4.822.256 3.136.274 5.424.012 9.593-.372 0 1.545-4.175 2.309-5.343 2.42-1.733.165-4.622.16-5.994 1.28-1.016.829-7.494 17.108-11.466 22.794-1.588 2.275-3.05 4.27-5.35 5.963-1.419 1.045-4.008 1.88-5.857 1.407-2.407-.617-5.157-4.686-6.99-7.995",
    fill: "#9C7141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.195 75.617c-4.146 0-9.912.972-13.72-.182-1.511-.459-2.975-1.889-3.927-3.098-.845-1.076-.626-1.08.07-2.004 5.683-7.535 35.319-5.145 38.558-4.284 3.85 1.025 8.783 2.926 11.824 5.378-3.248 4.127-15.218 4.058-18.161 3.993",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 70.765c5.764 0 34.23-.829 41-.414M109.563 68c-1.858-.84-3.73-2.544-4.346-4.537-.938-3.033 1.32-3.542 3.79-4.178 7.312-1.882 15.287-2.531 22.927-2.204 7.042.301 14.576 1.735 21.164 4.21 2.284.857 2.667 2.711.292 3.983-1.892 1.012-4.073 1.175-6.055 1.717-.394.109-.761.22-1.174.26.03.187.128.034.254.1",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.881 59c1.584-.402 4.653-1.533 5.062-3.29 1.056-4.542-12.853-4.599-17.034-4.954a198.887 198.887 0 0 0-16.228-.686c-3.759-.001-4.932-.226-8.646.137-1.296.126-5.454 1.786-5.985 3.847-.535 2.067 3.369 4.303 5.187 4.809M148.755 50.92c1.384.174 7.834.183 8.245-1.212-6.274-1.6-12.817-2.85-19.341-3.914-5.803-.947-11.677-.893-17.53-.623-5.25.241-11.038.507-16.129 1.899 2.414 1.097 6.074 2.13 8.739 1.923",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.045 47.205c0-2.762-.12-4.049.031-7.203 3.004-.021 39.924.16 39.924.298 0 2.509 0 5.661-.131 8.7M112.027 39.745c-.069-1.876 0-2.165.14-4.584 1.775-.265 11.066-.128 13.536-.108.082 1.524.185 5.01.297 4.946M125 34.518c1.358-1.35 4.497-1.772 6.357-1.96 2.96-.303 6.094-.667 9.094-.527 4.002.187 9.303.853 12.11 4.086 1.424 1.637-.929 2.978-2.634 3.384-.033.163-.036.33-.023.499",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.883 33.49c.37-.85 1.346-2.048 1.068-3.018-.274-.956-1.755-1.396-2.67-1.643-3.06-.826-6.437-1.058-9.646-1.377-7.565-.751-15.743-.535-23.205.42-1.43.182-3.703.5-4.303 2.02-.537 1.364.727 4.502 1.9 5.108",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16 27.904c-3.338.001-7.18-.254-10.16-1.644 1.902-.986 4.772-1.002 6.918-1.237 3.387-.371 6.867-.666 10.316-.822 7.01-.317 14.494-.505 21.212 1.408.539.153 1.047.225 1.554.548-.923 1.567-3.48 2.348-4.7 2.843",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "rdmhc832db",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v531xzn4da"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)",
    d: "M141 45h6v-4h-6zM73 70c-4.567 0-9.618.704-13.117 3.875C56.367 77.063 53.898 81.372 53 86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 70c-.793 5.459-4.893 8.263-9.246 8.889-5.109.737-9.574-2.255-11.39-7.1-.136-.363-.327-.829-.364-1.127",
    fill: "#9C7141",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 98c-4.2 4.607-9.453 9.584-13 14M52.365 86c-1.669 5.405-2.462 12.314-2.356 17.97 2.354.12 9.874-.17 12.991.013M64 92c-.143 6.067-.713 9.27-1 15M114.083 24.734c-4.5.538-14.051-4.191-5.9-6.448 5.606-1.55 12.97-1.096 18.837-1.152 6.697-.063 14.126-.59 20.515.994 1.792.444 5.925 1.26 5.423 3.395-.299 1.276-4.615 2.994-5.066 3.477",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.655 18c9.901-9.074-14.495-9.7-18.71-9.885-4.014-.175-10.169-.337-13.779 1.014-3.054 1.142-4.767 6.442-1.05 7.849M117.684 9l-.368-8M116 .5h28M144.5 1v10M80 82.1c5.382 0 8.182.96 13 .776M94 84c-.457 5.952-3.8 24.898-4 30",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 113c-5.197-.157-8.738-1-13-1M80 102c-.128 2.455-.72 6.857-1 10M79.872 83l-.744 6M93 83l-5 10M87 99l5 14M81 83l8 6M88 106l-10 6M87.823 95l-.646 3M106 94l-8 4",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.724 79c1.082 4.398-1.334 47.233-1.81 47.956-.73 1.11-2.894.94-4.199.936-6.07-.015-23.925.348-25.827-.18-1.424-.393-.708-4.543-.708-5.014",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 103c-.003-5.954 2.15-22.279 2.601-22.855.566-.721 19.07-1.034 21.504-1.063 1.407-.016 4.855-.177 5.895 0",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 84c-2.62 0-10.303.34-10.303.681 0 3.584-.35 9.717-.697 14.319M70 114c.126 2.029.174 5.766.174 7.863 0 .174 13.998.2 18.45-.027.408-2.52.375-5.177.375-7.836M93.262 127c.271 6.557.614 9.668.417 13M55 126c-.785 3.237-2.892 8.675-3 15M93 139.316c-7.323 0-32.998.227-40 .368",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 140.094c-.005 7.28.05 14.837-.316 22.196-5.82.302-11.203.72-16.99.374-.564-1.826-.83-4.628-1.196-6.485-2.846 3.408-4.184 6.821-4.892 6.821-4.421 0-12.184-.368-16.606-.764 1.01-6.092 3.137-15.132 5.263-22.236",
    fill: "#93C4BD",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 162c-1.09 14.336-1.412 20.108-2.91 29.674C83.494 201.88 81.469 211.936 80 222M81.09 222c-.334 4.042-1.16 7.966-1.336 11.274 3.54.209 7.055 1.292 10.366 2.445 3.148 1.097 8.021 3.722 2.07 4.129-5.03.342-21.99 0-21.16 0M73 161c0 23.76-4 46.128-4 69.875 0 2.85.085 5.82 1.122 8.125M78 181c.453 2.111 2.075 4.415 4 6",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 233c-1.83 2.234-9.12 4.465-10 1.75M79 226.685c-3.399-.013-7.337-.37-10-.37M82.981 233c-.247 1.389-.95 3.04-.962 3M84.976 234c-.43 1.368-1.43 3.223-.682 2.978",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 162.766c-1.748 4.79-5.265 30.998-13.574 27.995-4.674-1.69-8.77-10.099-10.881-14.203-3.073-5.973-4.668-11.626-7.738-17.465-2.113-4.019-2.466-4.83-7.104-5.526-2.26-.34-9.585-.117-9.703-2.819 6.994-1.121 15.484-.76 22.718-.34 3.5 6.924 5.168 12.581 10.161 18.396",
    fill: "#9C7141",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 160c-1.238 5.998-4.152 10.987-2.511 18M43 152c-1.882 0-10.849 1.326-9.935 3M47 160c-1.968.496-7.447 2.147-8 3M34 150c-.584 1.288-1.128 2.759-.973 3M30 150a10.25 10.25 0 0 1-1 3M40.228 148.75c2.906.076 7.99-.552 9.772-2.813-2.608-2.539-12.859-1.84-16.73-1.874-6.954-.063-13.912 0-20.866 0-3.064 0-17.246 1.156-8.703 3.67 5.572 1.642 9.746 1.642 16.006 2.267M5.367 143l.266-6M6 137.684l36-.368M44.303 137l.394 6M6.702 136.62c-2.024-.047-5.11-2.372-5.571-4.364-.729-3.143 1.72-3.91 4.173-4.408 5.085-1.033 11.223-.936 16.67-.673 5.692.275 11.529.948 17.01 2.02 1.949.382 5.488.515 6.94 2.033 1.566 1.638 1.583 4.835-1.022 5.748-.295.102-1.885-.16-1.406-.018",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 132.783c-6.5.972-13.395-1.598-19.872-2.227C18.185 129.982 12.057 130 6 130M41.038 123c1.43-.395 2.477-2.05 1.694-3.376-.526-.891-3.552-1.076-4.536-1.296-3.535-.793-7.367-.956-11.19-.956-5.01 0-19.023-1.796-22.006 2.501 1.102 1.498 3.416 3.06 5.33 2.502",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.694 117c.013-1.977.36-3.868.299-5.78-6.934-.212-13.89-.35-20.904-.034-.116 2.105-.173 3.361.18 5.508M32.642 109.973c1.825-.014 3.639.224 5.358-.492-3.422-3.307-12.558-3.376-16.857-3.536-4.415-.164-12.176-2.104-16.143.1 1.792 2.498 5.515 3.565 8.217 3.928",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.838 162.158c-6.46.676-14.69-.41-14.708.158-.324 9.472-1.429 17.375-1.432 23.995-.004 13.097-2.61 27.242-2.698 39.325 1.767.087 9.221.512 10.407.31.66-.111 3.447-20.502 4.578-25.9C87.202 189.523 88.192 175.892 89 162",
    fill: "#9C7141",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.134 234.686c-.208 2.966-.36 3.963 1.048 5.04.75.573 18.556.105 23.77-.123.802-2.857-8.582-4.367-12.273-5.225-4.986-1.16-6.233.716-10.747.766M41.19 149.113c1.055 1.12 1.72 2.558 1.81 3.98-2.242-.602-6.532.78-8.91.898-2.506.125-.914-1.058-3.314-1.29-3.967-.383-9.003.426-11.776-2.579 4.4-2.073 16.273-.617 22.309-.73",
    fill: "#F0612B",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.164 162.89c3.305-1.021 5.178-1.71 8.836-2.172-.887-2.867-3.526-7.257-4.116-7.432-2.934-.865-5.731.506-9.884.516.31 2.286 4.115 7.985 4.902 9.198",
    fill: "#FEFEFE",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 57.673c0 2.074-.48 3.9-.679 5.852-.19 1.878-.258 3.74-.586 5.583-.527 2.959-2.87 3.503-5.449 3.762-3.142.315-7.063.07-10.07-.874-.982-.307-4.184-1.735-2.929-2.794.968-.817 4.119-.787 5.398-.85 1.4-.067 1.379-.103 1.636-1.456.175-.91.5-1.781.71-2.67.43-1.806.509-3.713.965-5.582.377-1.541.204-3.588 2.086-3.641 2.636-.075 4.908 1.279 7.393 1.456M107.934 101.606c.305-.67-.533-2.695-.805-3.493-.355-1.04-.613-2.072-1.07-3.11-.904-.058-2.051.798-2.906 1.115-.936.348-1.907.621-2.788 1.043-.635.305-1.919.755-2.178 1.304-.309.656-.183 4.263.003 4.535M67 162.622c-3.884 0-7.763-.406-11.593-.61-1.354-.073-1.847.183-1.969 1.463-.094.974.135 1.784-.048 2.687-.154.755-.511 2.206-.348 2.94.28 1.264 1.308.903 2.454.641 1.724-.395 3.542-1.084 5.116-1.864",
    fill: "#9C7141",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.997 149c-2.357-.522-5.16-.354-7.638-.57-2.538-.223-5.094-.706-7.478-1.463-.728-.231-3.085-1.077-2.867-1.965.174-.712 2.461-.867 3.181-.995a45.172 45.172 0 0 1 7.96-.714c10.409 0 21.256-.751 31.664.151 1.898.164 4.997.19 6.181 1.811-3.775 2.521-9.26 2.88-13.818 2.315-4.777-.592-10.679-.14-15.272.72-.178.034-.967.178-.799.14",
    fill: "#C8AF66",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 40c-1.121-2.838-1.445-3.687-3.043-6.093-1.661-2.502-4.28-4.11-6.967-4.382-2.864-.292-5.409.75-7.688 2.504-2.294 1.764-3.609 4.227-5.302 6.275.377-7.402 7.104-12.66 11.548-12.285 7.431.627 10.751 6.636 11.391 11.993",
    fill: "#68493B",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.005 144.321c-.045-1.387.25-2.72.312-4.066.082-1.766-.487-2.447 1.211-2.765 2.414-.452 5.16-.059 7.607-.163a370.854 370.854 0 0 1 16.766-.325c3.398.01 6.741 1.07 10.026.837a67.576 67.576 0 0 1 0 6.295c-10.185.55-20.404-.024-30.592.512-.974.052-2.011.149-3.012.2-.53.027-2.54.436-2.166-.2",
    fill: "#FEF398",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.026 116.002c.57-.502-.309-4.146.074-6.67 6.763-.365 14.676-.826 20.9 1.034-.274 2.442-1.008 4.94-.979 7.634-5.143-.064-12.609-.826-16.569-1.479",
    fill: "#FEFEFE",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.342 109.416c-2.813.156-4.597-.73-6.342-3.65 3.012-1.643 9.764-.188 16.646.182 7.498.405 14.17.166 14.354 3.39-2.117.683-4.33.716-6.585.626",
    fill: "#FEF398",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.385 123.92c-2.538-1.31-4.277-2.124-4.378-2.93-.37-2.97 13.436-3.124 17.45-2.936 4.577.216 9.106.267 13.35 1.28 1.878.449 4.992.135 5.187 2.49.182 2.185-3.948 2.585-5.465 1.816",
    fill: "#C8AF66",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.517 84c-2.154.792-5.425.318-7.787.318-.822 0-3.325-.44-3.98-.008-.693.457-.595 2.68-.636 3.508-.261 5.27.009 10.63.009 15.908 0 3.061.313 5.99.158 9.068-.141 2.796.397 6.045.19 9.043 4.18.422 15.426-.1 18.537-.159.216-4.259.818-8.242.818-12.702 0-2.604.032-5.198.16-7.756.15-3.04-.896-5.934-.795-8.947",
    fill: "#FEFEFE",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 83.31c-2.598-.919-5.561-.657-8.28-.935-.815-.084-2.864-.683-3.58-.169-.682.489-.673 2.775-.746 3.62-.458 5.298-.4 10.568-1.448 15.725-.676 3.323-1.081 7.35-.905 10.827 3.849-.21 7.718.797 11.658.595-.276-5.151 1.086-9.989 1.394-15.038.151-2.492.665-4.969.813-7.392.078-1.264.001-2.614.123-3.809.095-.939-.08-3.101.335-3.907.135-.26.126-.01.324-.146",
    fill: "#FEF398",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 97.526c.638-1.38.846-3.428 1.09-5.195.234-1.686.397-3.467 1.112-4.956 1.906.095.346 5.367 1.248 6.523 1.862-2.02 5.873-7.717 7.977-7.898.034 2.025-1.919 4.77-2.83 6.476 1.35-.904 5.2-5.221 7.012-4.62 1.718.57-3.642 4.797-4.101 5.755 2.098-.556 4.3-1.38 6.476-1.426.35 1.919-5.281 3.528-6.363 4.513 1.48.48 4.516-.686 5.55.62-2.229 1.56-4.385 2.22-6.04 2.683-2.092.585-4.786 1.636-6.447 3.999",
    fill: "#9C7141",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 103c-2.107 3.842-5.576 9.48-7.82 13.278-2.369 4.011-4.532 7.184-8.977 8.897-1.7.655-4.058 1.546-5.411-.164-1.452-1.83-1.974-3.495-2.317-5.74-.75-4.9-.487-10.425-.062-16.126",
    fill: "#9C7141",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 104.146c.917-1.317 2.277-2.396 3.504-3.544 1.055-.986 1.936-2.324 3.043-3.202 1.812-1.436 3.241 1.336 3.915 2.94.884 2.103.827 3.24-1.3 4.4-1.343.734-5.62 3.164-6.99 1.903",
    fill: "#9C7141",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.008 102.56c.968.481-.03 3.483-.008 4.44.965-1 2.557-1.558 3.465-2.618.472-.55.688-.972.416-1.593-.408-.928-.805-.58-2.166-.789",
    fill: "#F69536",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.158 68c-1.645-.938-3.853-2.948-4.12-4.802-.418-2.892 2.725-3.395 4.75-4.2 5.65-2.247 12.581-1.147 18.547-1.722 6.156-.591 13.081-.31 18.86 1.601 2.18.722 5.214 1.598 6.978 3.161 2.597 2.302-1.595 3.5-3.333 4.361-4.068 2.015-8.617 1.008-13.154.65-6.783-.538-13.603.051-20.286.47",
    fill: "#C8AF66",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.666 59c-1.725-.135-5.091-1.633-5.583-3.625-.653-2.652 2.696-3.994 4.46-4.467 4.885-1.31 10.615-.814 15.776-.826 2.708-.006 5.303.525 7.963.661 2.691.136 5.309.084 7.928.367 2.159.233 14.567.941 11.221 5.124-3.816 4.77-9.895 1.28-14.724.986-5.616-.341-11.116-.711-16.688.092-1.704.244-3.374.498-5.097.697-.906.104-1.81.191-2.711.326-.509.076-2.082.394-1.748.5",
    fill: "#93C4BD",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.096 48.034c.077-2.52-.406-5.152.269-7.703 12.827-.687 26.379-.2 39.32.5.143 3 .464 6.264.235 9.169-2.868-.536-5.615-1.353-8.64-1.715-3.488-.416-6.972-1.25-10.55-1.25-6.213 0-14.862-1.137-20.165.75",
    fill: "#C8AF66",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.518 39.866c0-1.6.048-3.224-.037-4.81-4.454-.216-9.017.248-13.427.461a38.96 38.96 0 0 0 0 4.083c4.379.801 9.342.15 13.946.15",
    fill: "#9C7141",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 36.119c6.782-3.957 15.957-3.852 23.131-1.345 2.011.7 7.454 3.438 3.414 6.158-2.586 1.741-8.807.87-11.841.699-4.574-.257-9.516-.058-14.226-.257.223.267.163.285.418.385",
    fill: "#FEF398",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.088 34.944c-3.25 0-10.588.126-11.896 0-1.497-.146-2.425-2.355-2.14-4.294.302-2.065 1.754-2.58 3.568-3.088 3.59-1.004 7.93-.396 11.657-.198 3.874.206 7.92-.31 11.658.24 3.14.463 7.439.053 10.23 1.53 1.512.8 2.537 1.669 1.25 3.346-1.224 1.594-2.808.743-4.336.437-3.485-.698-7.307-1.056-10.95-.486-1.72.269-3.414.32-4.997.829-.707.228-1.579.517-2.3.757-.575.192-1.9.747-1.269.927",
    fill: "#F69536",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.529 27.794c-2.052.147-4.56-.075-6.511-.482-2.277-.475-3.004-1.586-.18-1.749 3.248-.187 8.134-1.213 11.755-1.392 7.88-.39 15.55-.19 22.964 1.4 1.114.239 2.736.182 3.443 1.017-1.367 1.096-4.494 1.766-5.426 2.412",
    fill: "#6D6063",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.915 23.6c-2.751 1.078-9.568-.119-10.644-2.452-1.759-3.81 5.542-4.124 7.588-4.432 7.514-1.135 15.923-.672 23.624-.292 3.68.18 7.757.135 11.296.902 1.114.243 4.259.7 4.922 1.777 1.174 1.902-1.385 3.564-2.877 4.2-3.593 1.53-7.813-.258-11.426-.66-3.71-.412-8.072-.561-11.72-.005-.893.136-1.793.332-2.631.484",
    fill: "#FEF398",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.029 17.431c-3.4-1.587-2.027-6.16.464-8.01 2.747-2.04 7.68-1.284 11.013-1.284 3.804 0 7.287.602 11.019.98 3.112.314 7.49.63 10.049 2.511 1.538 1.132 1.795 3.198.949 4.961-1.113 2.317-2.878 1.081-5.03 1.087-2.175.006-4.23-.245-6.427-.245h-5.51",
    fill: "#C8AF66",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#rdmhc832db)",
    d: "M141 45h6v-4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.715 75.34c-4.883-.333-10.1 1.976-14.675-.5-1.074-.582-4.59-2.84-3.966-4.359.472-1.149 4.834-2.724 5.987-3.239 4.393-1.962 10.484-1.923 15.338-2.142 6.077-.276 11.994.019 17.876.912 2.15.326 4.344 1.355 6.328 2.258 1.902.865 4.284 1.492 5.397 3.255-3.236 2.96-9.3 3.322-13.465 3.509-5.224.234-10.361.204-15.499.001-.368-.016-.74 0-1.107 0",
    fill: "#FEF398",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.993 127.067c-2.391-.25-5.172-1.105-7.993-2.44 5.642-1.795 15.167-1.88 21.47-1.324 5.749.507 15.986-.794 19.53 2.574-6.792 2.274-14.243 3.93-20.313 2.71",
    fill: "#6D6063",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.677 137.234c-2.691-.174-6.226-3.48-5.605-6.428.64-3.033 5.48-3.29 8.252-3.572 7.793-.793 15.649.636 23.039 1.198 3.392.257 6.849 1.56 10.29 2.129 3.886.642 6.426 4.84 2.042 6.614-2.963 1.198-8.24.61-11.391.773-3.815.198-7.567-.238-11.445-.238-2.556 0-5.156-.142-7.708 0-1.284.072-2.456.218-3.737.238-.933.016-3.187.015-2.802-.238",
    fill: "#C8AF66",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.659 26.01c13.537-.47 14.47 16.745 9.783 25.538-2.553 4.788-7.251 8.03-12.974 7.366-5.609-.65-7.913-7.128-8.363-11.787-.42-4.356.465-9.01 1.95-12.886 2.132-5.566 5.373-7.54 9.25-8.232",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.047 29c5.883-4.263 7.531-16.03-.67-17.821-3.478-.76-7.015.91-8.46 4.805-1.56 4.209-1.078 8.04 1.053 11.405M87 59c-.79 4.983-1.452 9.268-3 13M75 56c-.93 3.615-3.054 13.814-2.999 12.948M73 38.661C66.152 34.89 64.376 48.468 71.857 49M95.726 41.093c6.927-1.238 4.77 10.258-1.726 9.899",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 44c-1.2 1.362-1.691 2.18-3 3M73 43c-.008-.007-2.894-2.92-3-3M90.684 40c-.046 1.444-.046 2.445-.368 4M79.684 40c-.093 1.594-.23 2.016-.368 3M86.882 40c.045 1.43.92 8.26-2.882 5.235M88.73 49.734c-3.924 0-6.343-.11-9.709-1.734-.201 3.203 1.032 5.314 3.724 5.861 3.674.75 5.301-1.667 6.255-4.127M85 69.828c3.055-.788 4.61-1.032 6.396-.653 2.662.563 4.916 1.722 6.492 4.07 1.836 2.73 2.585 5.973 3.566 9.1a269.716 269.716 0 0 1 2.386 7.985c.854 3.041 2.08 8.784 2.16 8.668",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.466 99.853c1.694-2.815 11.075-15.337 13.861-19.793.84-1.343 1.651-2.724 3.258-2.944 1.675-.23 3.191.114 4.822.256 3.136.274 5.424.012 9.593-.372 0 1.545-4.175 2.309-5.343 2.42-1.733.165-4.622.16-5.994 1.28-1.016.829-7.494 17.108-11.466 22.794-1.588 2.275-3.05 4.27-5.35 5.963-1.419 1.045-4.008 1.88-5.857 1.407-2.407-.617-5.157-4.686-6.99-7.995M124.144 75.617c-4.153 0-9.928.972-13.742-.182-1.514-.459-2.964-1.9-3.933-3.098-.645-.799-.627-1.08.07-2.004 5.691-7.535 35.374-5.145 38.619-4.284 3.856 1.025 8.796 2.926 11.842 5.378-3.253 4.127-15.242 4.058-18.19 3.993",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 70.765c5.764 0 34.23-.829 41-.414M109.536 68c-1.857-.857-3.704-2.377-4.32-4.41-.937-3.091 1.321-3.611 3.792-4.26 7.31-1.918 15.286-2.58 22.927-2.248 7.041.309 14.576 1.77 21.164 4.293 2.282.874 2.665 2.766.291 4.061-1.892 1.034-4.073 1.2-6.054 1.753-.394.11-.762.224-1.175.264.03.19.128.035.254.103",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.881 59c1.584-.402 4.653-1.533 5.062-3.29 1.056-4.542-12.853-4.599-17.034-4.954a198.887 198.887 0 0 0-16.228-.686c-3.759-.001-4.932-.226-8.646.137-1.296.126-5.454 1.786-5.985 3.847-.535 2.067 3.369 4.303 5.187 4.809M148.755 50.92c1.384.174 7.834.183 8.245-1.212-6.274-1.6-12.817-2.85-19.341-3.914-5.803-.947-11.677-.893-17.53-.623-5.25.241-11.038.507-16.129 1.899 2.414 1.097 6.074 2.13 8.739 1.923",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.045 47.205c0-2.762-.12-4.049.031-7.203 3.004-.021 39.924.16 39.924.298 0 2.509 0 5.661-.131 8.7M112.027 39.745c-.069-1.876 0-2.165.14-4.584 1.775-.265 11.066-.128 13.536-.108.082 1.524.185 5.01.297 4.946M125 34.518c1.358-1.35 4.497-1.772 6.357-1.96 2.96-.303 6.094-.667 9.094-.527 4.002.187 9.303.853 12.11 4.086 1.424 1.637-.929 2.978-2.634 3.384-.033.163-.036.33-.023.499",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.883 33.49c.37-.85 1.346-2.048 1.068-3.018-.274-.956-1.755-1.396-2.67-1.643-3.06-.826-6.437-1.058-9.646-1.377-7.565-.751-15.743-.535-23.205.42-1.43.182-3.703.5-4.303 2.02-.537 1.364.727 4.502 1.9 5.108",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16 28.1c-3.338.001-7.18-.45-10.16-1.84 1.902-.987 4.772-1.002 6.918-1.237a163.46 163.46 0 0 1 10.316-.822c7.01-.317 14.494-.505 21.212 1.407.539.154 1.047.226 1.554.55-.923 1.566-3.48 2.347-4.7 2.842M141 45h6v-4h-6zM73 70c-4.567 0-9.618.704-13.117 3.875C56.367 77.063 53.898 81.372 53 86",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 70c-.793 5.459-4.893 8.263-9.246 8.889-5.109.737-9.574-2.255-11.39-7.1-.136-.363-.327-.829-.364-1.127M71 97.526c.638-1.38.846-3.428 1.09-5.195.234-1.686.397-3.467 1.112-4.956 1.906.095.346 5.367 1.248 6.523 1.862-2.02 5.873-7.717 7.977-7.898.034 2.025-1.919 4.77-2.83 6.476 1.35-.904 5.2-5.221 7.012-4.62 1.718.57-3.642 4.797-4.101 5.755 2.098-.556 4.3-1.38 6.476-1.426.35 1.919-5.281 3.528-6.363 4.513 1.48.48 4.516-.686 5.55.62-2.229 1.56-4.385 2.22-6.04 2.683-2.092.585-4.786 1.636-6.447 3.999M77 104.357c-2.075 3.53-4.875 8.221-7.084 11.71-2.333 3.686-4.462 6.601-8.84 8.175-1.674.602-3.994 1.42-5.328-.15-1.43-1.683-1.943-3.212-2.28-5.276-.739-4.502-.48-9.577-.062-14.816",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 98c-4.2 4.607-9.453 9.584-13 14M52.365 86c-1.669 5.405-2.462 12.314-2.356 17.97 2.354.12 9.874-.17 12.991.013M64 92c-.143 6.067-.713 9.27-1 15M113.43 24.943c-4.486.537-13.225-4.4-5.1-6.656 5.588-1.552 12.927-1.098 18.776-1.153 6.674-.062 14.079-.59 20.447.995 1.786.444 5.905 1.26 5.405 3.394-.299 1.277-4.6 2.994-5.05 3.477",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.655 18c9.901-9.074-14.495-9.7-18.71-9.885-4.014-.175-10.169-.337-13.779 1.014-3.054 1.142-4.767 6.442-1.05 7.849M117.684 9l-.368-8M116 .5h28M144.5 1v10M80 82.1c5.382 0 8.182.96 13 .776M94 84c-.457 5.952-3.8 24.898-4 30",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 113.933c-5.22-.185-8.719-.866-13-.866M80 102c-.128 2.455-.72 6.857-1 10M79.872 83l-.744 6M93 83l-5 10M87 99l5 14M81 83l8 6M88 106l-10 6M87.823 95l-.646 3M106 94l-8 4",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.724 79c1.082 4.398-1.334 47.233-1.81 47.956-.73 1.11-2.894.94-4.199.936-6.07-.015-23.925.348-25.827-.18-1.424-.393-.708-4.543-.708-5.014",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 103c-.003-5.954 2.15-22.279 2.601-22.855.566-.721 19.07-1.034 21.504-1.063 1.407-.016 4.855-.177 5.895 0",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 84c-2.62 0-10.303.34-10.303.681 0 3.584-.35 9.717-.697 14.319M70 114c.126 2.029.174 5.766.174 7.863 0 .174 13.998.2 18.45-.027.408-2.52.375-5.177.375-7.836M93.262 127c.271 6.557.614 9.668.417 13M55 126c-.785 3.237-2.892 8.675-3 15M93 139.316c-7.323 0-32.998.227-40 .368M90 140.094c-.005 7.28.05 14.837-.316 22.196-5.82.302-11.203.72-16.99.374-.564-1.826-.83-4.628-1.196-6.485-2.846 3.408-4.184 6.821-4.892 6.821-4.421 0-12.184-.368-16.606-.764 1.01-6.092 3.137-15.132 5.263-22.236",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 162c-1.09 14.336-1.412 20.108-2.91 29.674C83.494 201.88 81.469 211.936 80 222M81.09 222c-.57 4.586-1.16 7.966-1.336 11.274 3.54.209 7.055 1.292 10.366 2.445 3.148 1.097 8.021 3.722 2.07 4.129-5.03.342-21.99 0-21.16 0M73 161c0 23.75-3.971 46.107-3.971 69.844 0 2.848-.259 5.852.771 8.156M78 181c.453 2.111 2.075 4.415 4 6",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 232c-1.795 1.915-9.137 4.382-10 2.054M79 226.685c-3.399-.013-7.337-.37-10-.37M82.981 233c-.247 1.342-.95 3.038-.962 3M85 234c-.502 1.434-.421 2.022-1 3M67 162.766c-1.748 4.79-5.265 30.998-13.574 27.995-4.674-1.69-8.77-10.099-10.881-14.203-3.073-5.973-4.668-11.626-7.738-17.465-2.113-4.019-2.466-4.83-7.104-5.526-2.26-.34-9.585-.117-9.703-2.819 6.994-1.121 15.484-.76 22.718-.34 3.5 6.924 5.168 12.581 10.161 18.396",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 162c-1.238 5.451-4.152 9.625-2.511 16M43 152c-1.882 0-10.849 1.326-9.935 3M47 160c-1.968.496-7.447 2.147-8 3M33.956 150c-.663 1.613-1.046 2.698-.87 3M30 150a10.25 10.25 0 0 1-1 3M40.228 148.75c2.906.076 7.99-.552 9.772-2.813-2.608-2.539-12.859-1.84-16.73-1.874-6.954-.063-13.912 0-20.866 0-3.064 0-17.246 1.156-8.703 3.67 5.572 1.642 9.024 1.642 15.285 2.267M5.367 143l.266-6M6 137.684l36-.368M44.303 137l.394 6M6.702 137c-2.024-.047-5.11-2.833-5.571-4.802-.729-3.108 1.72-3.866 4.173-4.36 5.085-1.02 11.223-.925 16.67-.665 5.692.271 11.529.937 17.01 1.997 1.949.379 5.488.51 6.94 2.01 1.566 1.62 1.583 4.782-1.022 5.684-.295.102-1.885-.158-1.406-.017",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 132.783c-6.5.972-13.395-1.598-19.872-2.227C18.185 129.982 12.057 130 6 130M9.35 127.144c-2.122.181-4.263-1.05-6.35-2.43 6.585-2.498 15.208-1.529 22.338-1.529 5.047 0 14.861-.39 18.662 2.8a21.076 21.076 0 0 1-4.368 1.89c-1.02.307-3.8.872-3.071 1.125",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.038 124c1.43-.377 2.477-2.23 1.694-3.497-.526-.85-3.552-1.025-4.536-1.236-3.535-.756-7.367-.912-11.19-.912-5.01 0-19.023-1.713-22.006 2.387 1.102 1.429 3.232 2.666 5.308 2.734M33.694 117c.013-1.977.36-3.868.299-5.78-6.934-.212-13.89-.35-20.904-.034-.116 2.105-.173 3.361.18 5.508M32.642 110c1.825-.012 3.639-.221 5.358-.88-3.182-3.445-12.558-3.103-16.857-3.25-4.415-.151-12.176-1.936-16.143.092 1.792 2.296 5.515 3.647 8.217 3.98",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#rdmhc832db)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryGirl);
export default __webpack_public_path__ + "static/media/delivery_girl.d3a39db1c48c2e36da80b97b35228a32.svg";
export { ForwardRef as ReactComponent };